import React from "react"
import SearchIcon from "../../images/search-3.svg"

export default function SearchField(props) {
  const [search, setSearch] = React.useState("")
  const handleKeyPress = e => {
    if (e.key === "Enter") {
      props.onChange(search)
    }
  }

  return (
    <div className="row pb-16px">
      <div className="col-lg-10 ">
        <div className="wscw-search-field ">
          <div className="row align-items-center">
            <div className="col-9">
              <div className="d-flex justify-content-start align-items-center gap-12px ">
                <div className="search-icon">
                  <img src={SearchIcon} alt="" className="img-fluid" />
                </div>
                <div className="search-field">
                  <input
                    id="search"
                    type="text"
                    placeholder="Search Job"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                    onKeyDown={handleKeyPress}
                  />
                </div>
              </div>
            </div>

            <div className="col-3 text-end">
              <a
                href="#"
                className="btn btn-filled-v3"
                onClick={e => {
                  e.preventDefault()
                  props.onChange(search)
                }}
              >
                Search
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
